import { BuildUri } from './BuildUri'
import { NetworkManager } from '../context'
import {
    SupportTicket,
    SupportTicketRecipient,
    SupportTicketRequest,
    SupportTicketTriageRequest,
} from '../model/SupportTicket'

class SupportEndpoints {
    createTicket(request: SupportTicketRequest): Promise<SupportTicket> {
        return NetworkManager.fetch(BuildUri('/support/ticket'), {
            method: 'POST',
            body: request,
        })
    }

    listTickets(): Promise<SupportTicket[]> {
        return NetworkManager.fetch(BuildUri('/support/ticket'))
    }

    getTicket(id: number): Promise<SupportTicket> {
        return NetworkManager.fetch(BuildUri('/support/ticket/{id}', { id }))
    }

    triageTicket(
        id: number,
        request: SupportTicketTriageRequest
    ): Promise<SupportTicket> {
        return NetworkManager.fetch(BuildUri('/support/ticket/{id}', { id }), {
            method: 'PATCH',
            body: request,
        })
    }

    /** Returns a relative URL that downloads the attachment binary. */
    attachmentUrl(attachmentId: number): string {
        return BuildUri('/support/ticket/attachment/{attachmentId}', {
            attachmentId,
        })
    }

    listRecipients(): Promise<SupportTicketRecipient[]> {
        return NetworkManager.fetch(BuildUri('/support/recipient'))
    }

    addRecipient(email: string): Promise<SupportTicketRecipient> {
        return NetworkManager.fetch(BuildUri('/support/recipient'), {
            method: 'POST',
            body: { email },
        })
    }

    removeRecipient(id: number): Promise<{ removed: boolean }> {
        return NetworkManager.fetch(
            BuildUri('/support/recipient/{id}', { id }),
            { method: 'DELETE' }
        )
    }
}

export default new SupportEndpoints()
